import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import parse from "html-react-parser"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import StatisticsCardsRating from "../StatisticsCardsRating"
import PubSub from "pubsub-js"
import { navigate } from "vike/client/router"

const PWUFooterSection = () => {
  return (
    <div className="flex flex-col w-full align-center bg-gradient_pwu_become_partner px-px1_l xl:px-px1_xl pt-[30px] md:pt-[56px] lg:pt-[109px] pb-[60px] md:pb-[70px] lg:pb-[116px] rounded-[50px] md:rounded-[100px]">
      {/* White Container */}
      <CMSRender
        contentType="PageSection"
        match={{ "content.name": "PWUFooterSection" }}
        renderItem={(data, id) => {
          const handleContact = () => PubSub.publish( data.menu?.[0].options?.action )

          return (
            <div
              key={id}
              className="flex flex-col w-full lg:max-w-[1062px] xl:max-w-w2_xl items-center justify-center bg-paper rounded-[50px] md:rounded-[56px] lg:rounded-[70px] px-[40px] pt-[82px] pb-[88px] mb-[40px] lg:mb-[70px] mx-auto"
            >
              {/* Heading */}
              <Typography 
                component="h2" 
                variant="h1" 
                className="text-text text-center mb-[28px]"
              >
                <div key={id}>
                  {data.title && typeof data.title === 'string' ? parse(data.title) : data.title || 'Default Title'}
                </div>
              </Typography>

              {/* Subheading */}
              <Typography 
                variant="body1" 
                className="text-center mt-0 mb-[26px]"
              >
                {data.description && typeof data.description === 'string' ? parse(data.description) : data.description || 'Default description'}
              </Typography>

              {/* Contact Us Button */}
              <Button
                key={id}
                onClick={handleContact}
                variant="primary_l"
                className="lg:min-w-[214px]"
              >
                {data.menu?.[0]?.label || 'Contact Us'}
              </Button>
            </div>
          )
        }}
      />
      <StatisticsCardsRating />
    </div>
  )
}

export default PWUFooterSection
